import { LegalPage } from "@/components/legal/LegalPage";
import { SELLER } from "@/config/legal";

const PrivacyPolicy = () => (
  <LegalPage title="Privacy Notice" description="How Veylo AI collects, uses and protects your personal data." path="/privacy-policy">
    <section>
      <h2>1. Who is responsible</h2>
      <p>
        <strong>{SELLER.legalName}</strong>, trading as {SELLER.tradingName}, operates {SELLER.productName} ({SELLER.website}) and is the data controller for the personal data described here.
        Contact: <a href={`mailto:${SELLER.supportEmail}`}>{SELLER.supportEmail}</a>.
      </p>
    </section>
    <section>
      <h2>2. What we collect and why</h2>
      <ul>
        <li><strong>Account details</strong> (name, email, login credentials, company, profile photo) — to create and run your account.</li>
        <li><strong>Data you upload or enter</strong> (spreadsheets, text, voice, images, connected CRM data) — to provide analysis, dashboards, forecasts and reports.</li>
        <li><strong>Support and feedback messages</strong> — to help you.</li>
        <li><strong>Usage and device data</strong> (pages used, features, device, browser, IP address) — to keep the service secure, prevent fraud and improve it.</li>
        <li><strong>Email preferences</strong> — to send reports and, where you agree, product updates.</li>
      </ul>
      <p className="mt-2">Card and payment details are collected directly by Paddle, not by us.</p>
    </section>
    <section>
      <h2>3. Legal basis</h2>
      <ul>
        <li>Contract — to provide the service you signed up for.</li>
        <li>Legitimate interests — security, fraud prevention, and improving the product.</li>
        <li>Consent — optional analytics cookies and marketing emails; you can withdraw at any time.</li>
        <li>Legal obligation — where the law requires us to keep or share information.</li>
      </ul>
    </section>
    <section>
      <h2>4. Who we share data with</h2>
      <ul>
        <li>Service providers who host and run the service (cloud hosting, database, email delivery, AI model providers, analytics).</li>
        <li><strong>Paddle.com</strong>, our Merchant of Record, for selling the product, subscription management, payments, tax compliance and invoicing.</li>
        <li>Professional advisers (legal, accounting).</li>
        <li>Authorities, where required by law.</li>
      </ul>
      <p className="mt-2">We do not sell your personal data. Some providers are outside your country; where that happens we rely on appropriate safeguards such as standard contractual clauses.</p>
    </section>
    <section>
      <h2>5. How long we keep data</h2>
      <p>Account data is kept while your account is open. Workflow data is automatically deleted after 90 days. After account closure, data is deleted or anonymised within 30 days unless the law requires us to keep it longer.</p>
    </section>
    <section>
      <h2>6. Your rights</h2>
      <p>You can ask to access, correct, delete, restrict or export your data, object to processing, or withdraw consent. Many of these are available in Settings; otherwise email us and we will respond within one month. You may also complain to your data protection authority (in Nigeria, the Nigeria Data Protection Commission).</p>
    </section>
    <section>
      <h2>7. Security</h2>
      <p>We use encryption in transit, access controls, per-user data isolation and regular security reviews to protect your data.</p>
    </section>
    <section>
      <h2>8. Cookies</h2>
      <p>We use essential cookies to keep you signed in, and — only with your consent — analytics cookies to understand how the product is used. You can change your choice any time through the cookie banner or your browser settings.</p>
    </section>
    <section>
      <h2>9. Changes</h2>
      <p>We will post updates here and notify you of material changes.</p>
    </section>
  </LegalPage>
);

export default PrivacyPolicy;
